import ToggleSound from './ToggleSound';

export default ToggleSound;
